// extracted by mini-css-extract-plugin
export default {"l":"cc21bf2904"};